<template>
  <DragDialog
    class="inner-pop-primary"
    title="新建分组"
    :width="400"
    :visible.sync="visible"
    :footerBtn="['submit', 'cancel']"
    :submit="submit"
    :cancel="closeDialog"
  >
    <div class="anchor-group-form-box">
      <el-form
        :model="groupForm"
        :rules="rules"
        ref="groupForm"
        class="public-form-primary"
        label-width="80px"
      >
        <el-form-item label="分组名称：" prop="groupName">
          <el-input
            size="small"
            class="input-primary"
            :maxlength="30"
            v-model="groupForm.name"
            placeholder="请输入分组名称"
          />
        </el-form-item>
      </el-form>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";

import { createSceneAnchorGroupService } from "@/service/interface";

export default {
  data() {
    return {
      groupForm: {
        name: "",
      },

      rules: {
        name: [
          {
            required: true,
            message: "请输入分组名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: {
    visible: Boolean,
    refreshAnchorGroupList: Function,
  },
  components: {
    DragDialog,
  },
  methods: {
    submit() {
      let sceneId = this.$route.query.sceneId;
      let params = { sceneId, name: this.groupForm.name };
      createSceneAnchorGroupService(params).then((response) => {
        if (response.isSuccess) {
          let groupId = response.data;
          this.refreshAnchorGroupList(groupId).then(() => {
            this.$message.success("新建分组成功");
            this.closeDialog();
          });
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    closeDialog() {
      this.groupForm = { name: "" };
      this.$emit("closeAnchorGroupDialog");
    },
  },
};
</script>

<style lang="less" scoped>
:deep(.dialog-content) {
  .anchor-group-form-box {
    .public-form-primary {
      .el-form-item {
        margin-bottom: 0px;
        .el-form-item__label {
          padding: 0px;

          &::before {
            margin-right: 2px;
          }
        }
      }
    }
  }
}
</style>